export const PROFITS_UPDATE_LIST = 'PROFITS_UPDATE_LIST'
export const PROFITS_SET_FETCHING = 'PROFITS_SET_FETCHING'
